import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const DataOptionPage = () => {
  return (
    <HomeUI />
  )
}

export default DataOptionPage;
